import axiosClient from "api/apiClient";
export const APICreateTestManny = (data: object) => {
    return axiosClient.post("/tests/createManny", data);
};

export const APICreateTestCustomManny = (data: object) => {
    return axiosClient.post("/tests/createMannyPersonal", data);
};